<template>
  <div class="block grid">
    <div class="block text-700 text-center">
      <div class="surface-section px-4 py-8 md:px-6 lg:px-8">
        <div
          class="flex justify-content-center flex-wrap card-container yellow-container"
        >
          <div
            class="flex align-items-center justify-content-center w-4rem h-4rem font-bold text-gray-900 border-round m-2"
          >
            <img
              src="images/ids_logo.svg"
              alt="Image"
              class="scalein animation-ease-in-2000 animation-delay-4000 animation-duration-3000 animation-iteration-infinite logo_w logo_h"
            />
          </div>
        </div>
        <div class="mt-8 text-900 font-bold text-5xl mb-3">
          BIENVENUE SUR IDS CHAT BOT!
        </div>
        <div class="text-700 text-2xl mb-5">
          <span style="color: black">{{ user.username }}</span> vous êtes
          connecté en tant que
        </div>
        <Button
          v-if="user.type_id == 1"
          label="Superviseur"
          icon="pi pi-discord"
          class="text-black font-bold px-5 py-3 p-button-rounded white-space-nowrap"
        ></Button>
        <Button
          v-else-if="user.type_id == 3"
          label="Reporting"
          icon="pi pi-discord"
          class="text-black font-bold px-5 py-3 p-button-rounded white-space-nowrap"
        ></Button>
        <Button
          v-else
          label="Conseiller"
          icon="pi pi-discord"
          class="font-bold px-5 py-3 p-button-rounded white-space-nowrap mr-2"
        ></Button>

        <div v-for="client in clients" :key="client.id" class="client-control">
          <Button
            :label="
              statusClients[client.id]
                ? `WhatsApp ${client.label} connecté (${
                    connectedNumbers[client.id] || '...'
                  } )`
                : `Démarrer WhatsApp ${client.label}`
            "
            icon="pi pi-whatsapp"
            :class="[
              'font-bold px-5 py-3 p-button-rounded white-space-nowrap',
              statusClients[client.id] ? 'p-button-success' : '',
            ]"
            :disabled="statusClients[client.id]"
            @click="startWhatsApp(client.id)"
          />

          <Button
            :label="`Supprimer la session WhatsApp ${client.label}`"
            icon="pi pi-times"
            class="p-button-danger font-bold px-5 py-3 p-button-rounded white-space-nowrap mt-2"
            @click="deleteSession(client.id)"
          />
        </div>

        <div v-if="toastMessage" class="custom-toast">{{ toastMessage }}</div>

        <div v-if="isLoading" class="text-center mt-4">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
          <p>Chargement du QR Code...</p>
        </div>

        <div v-if="qrCodeUrl" class="mt-4 text-center">
          <h4>Scannez ce QR code avec WhatsApp</h4>
          <img :src="qrCodeUrl" alt="QR Code WhatsApp" />
        </div>
      </div>
    </div>
    <!-- <div class="col-12">
      <div class="card">
        <h5>MCB</h5>
        <p>BIENVENUE SUR MC CHAT</p>
        <p>VOUS ETES CONNECTE EN TANT QUE [ {{user.username}} ] 
<span v-if="user.type_id==1">@<span style="border-style: none; padding:0.5rem; color:green">SUPERVISEUR </span> </span>
<span v-else>@<span style="border-style: none; padding:0.5rem; color:green">CONSEILLER </span> </span>
           <span v-if="user.type_id==1">@<span style="padding-right:1rem"></span> <button style="border-style: none; padding:0.5rem;background-color:green; color:white">SUPERVISEUR </button> </span>
<span v-else>@<span style="padding-right:1rem"></span> <button style="border-style: none; padding:0.5rem;background-color:green; color:white">CONSEILLER </button> </span> 
        </p>
      </div>
    </div> -->
  </div>
</template>

<script>
//import { FilterMatchMode } from "@primevue/api";
import axios from "axios";
import { API_URL } from "../settings";

export default {
  data() {
    return {
      user: {},
      statusClients: {},
      qrCodeUrl: null,
      toastMessage: null,
      isLoading: false,
      connectedNumbers: {},

      clients: [
        { id: 1, label: "1" },
        { id: 2, label: "2" },
        { id: 3, label: "3" },
        { id: 4, label: "4" },
      ],
    };
  },
  mounted() {
    const o = JSON.parse(localStorage.getItem("user"));
    this.user = o;
    this.checkAllClientsStatus();
  },
  methods: {
    async saveAllGroupsForNumber(phone_number, groups, name_profile) {
      for (const group of groups) {
        try {
          // Vérifie si ce lien existe déjà (recherche par id_group)
          const existing = await axios.get(`${API_URL}api/mc_chat/emoji-links`);
          const found = existing.data.find(
            (e) => e.id_group === group.id && e.phone_number === phone_number
          );

          if (found) {
            // Mise à jour (PUT)
            await axios.put(`${API_URL}api/mc_chat/emoji-links/${found.id}`, {
              phone_number,
              emoji: found.emoji || "", // Garde l'emoji existant ou un par défaut
              name_profile,
              id_group: group.id,
              name_group: group.name,
            });
            console.log(`Mis à jour : ${group.name}`);
          } else {
            // Création (POST)
            await axios.post(`${API_URL}api/mc_chat/emoji-links`, {
              phone_number,
              emoji: "", // ou personnalisé
              name_profile,
              id_group: group.id,
              name_group: group.name,
            });
            console.log(` Créé : ${group.name}`);
          }
        } catch (err) {
          console.error(`❌ Erreur pour le groupe ${group.name}`, err);
        }
      }
    },
    async startWhatsApp(clientId) {
      await fetch(`https://gigatech.ga/api/mc_chat/start-whatsapp/${clientId}`);
      this.fetchQrCode(clientId);
    },
    async fetchQrCode(clientId) {
      this.qrCodeUrl = null;
      this.isLoading = true;

      const qrInterval = setInterval(async () => {
        const res = await fetch(
          `https://gigatech.ga/api/mc_chat/qr/${clientId}`
        );
        const data = await res.json();
        if (data.qr) {
          this.qrCodeUrl = data.qr;
          this.isLoading = false;
        }
      }, 2000);

      const statusInterval = setInterval(async () => {
        const res = await fetch(
          `https://gigatech.ga/api/mc_chat/status/${clientId}`
        );
        const data = await res.json();
        if (data.isReady) {
          clearInterval(statusInterval);
          clearInterval(qrInterval);
          this.qrCodeUrl = null;
          this.toastMessage = "Connexion WhatsApp établie avec succès.";
          this.isLoading = false;

          this.statusClients[clientId] = true; // 👈 Ici tu mets à jour l’état connecté

          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      }, 3000);
    },
    async deleteSession(clientId) {
      const res = await fetch(
        `https://gigatech.ga/api/mc_chat/delete-session/${clientId}`
      );
      const data = await res.json();
      this.toastMessage = data.message || "Session supprimée.";
      this.qrCodeUrl = null;
      setTimeout(() => {
        this.toastMessage = null;
      }, 4000);

      this.statusClients[clientId] = false;
    },

    async checkAllClientsStatus() {
      for (const client of this.clients) {
        try {
          const res = await fetch(
            `https://gigatech.ga/api/mc_chat/status/${client.id}`
          );
          const data = await res.json();

          this.statusClients[client.id] = data.isReady;

          if (data.isReady && data.number) {
            this.connectedNumbers[client.id] = data.number;

            // ⬇️ Appelle ici la fonction pour sauvegarder les groupes associés
            if (data.groups && data.groups.length > 0) {
              await this.saveAllGroupsForNumber(
                data.number,
                data.groups,
                data.pushname
              );
            }
          }
        } catch (err) {
          console.error("Erreur de statut client", client.id, err);
          this.statusClients[client.id] = false;
        }
      }
    },
  },
};
</script>
<style scoped>
.logo_h {
  height: 20vh !important;
}
.logo_w {
  width: 20vh !important;
}

.margin-right-10 {
  margin-right: 10px; /* ou la valeur que tu veux */
}

.custom-toast {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: #323232;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  z-index: 9999;
  animation: fadeInOut 4s ease;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  10% {
    opacity: 1;
    transform: translateY(0);
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(20px);
  }
}
</style>
